import { useState, useEffect } from 'react';
import { parseImageQuery, parseImageQueryGrid } from './utils';

export const useMedia = (queries, values, defaultValue) => {
	const mediaQueryLists = queries.map(q => window.matchMedia(q));

	const getValue = () => {
		const index = mediaQueryLists.findIndex(mql => mql.matches);
		return typeof values[index] !== 'undefined' ? values[index] : defaultValue;
	};

	const [value, setValue] = useState(getValue);

	useEffect(() => {
		const handler = () => setValue(getValue);
		mediaQueryLists.forEach(mql => mql.addListener(handler));
		return () => mediaQueryLists.forEach(mql => mql.removeListener(handler));
	}, []);

	return value;
};

export const useImages = imageQuery => {
	const [images, setImages] = useState([]);
	const [heroImage, setHeroImage] = useState(null);

	useEffect(() => {
		const [galleryImages, heroImage] = parseImageQuery(imageQuery);
		setImages(
			galleryImages
				.filter(image => image.imageName.indexOf('hero') < 0)
				.sort((a, b) =>
					a.imageName.localeCompare(b.imageName, 'et', {
						numeric: true,
						ignorePunctuation: true
					})
				)
		);
		setHeroImage(heroImage);
	}, [imageQuery]);

	return [images, heroImage];
};

export const useGridGalleryImages = (imageQuery, dataSetKey) => {
	const [images, setImages] = useState([]);

	useEffect(() => {
		const gridImages = parseImageQueryGrid(imageQuery, dataSetKey);
		setImages(
			gridImages.sort((a, b) =>
				a.imageName.localeCompare(b.imageName, 'et', {
					numeric: true,
					ignorePunctuation: true
				})
			)
		);
	}, [imageQuery]);

	return images;
};
